import React, { useEffect, useState } from 'react';

import { 
  Character,
  CharacterSheetInterface,
  CustomParticipant,
} from "@dndModels";
import CommonUtilities from "@utilities/common_utilities";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import FlexBox from '@components/layout/FlexBox';
import StringBox from '@components/input/strings/StringBox';

interface Props {
  char: CharacterSheetInterface;
  disabled?: boolean;
  // onChange: () => void;
}

const common_util = CommonUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterMaxHPCustomizations({ 
  char,
  disabled = false,
}: Props) {
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <FlexBox direction="row">
      <FlexBox className="header centered" style={{ width: "33%" }}>
        Max HP: { char.hp.true_max }
      </FlexBox>
      <FlexBox style={{ width: "34%" }}>
        <StringBox 
          name={`Max ${ char.hp.called } Modifier`}
          value={ char.body.hp.max_modifier === 0 ? "" : `${char.body.hp.max_modifier}` }
          type="number"
          onBlur={(changed: string) => {
            let new_mod = 0;
            if (changed === "") {
              new_mod = 0;
            } else {
              new_mod = +changed;
            }
            char.hp.max_modifier = new_mod;
            const new_current = char.body.hp.current > char.hp.true_max ? char.hp.true_max : char.body.hp.current;
            char.hp.current = new_current;
            char.changed();
            char.subscription_holder.resourcesChanged();
            setReloading(true);
          }}
        />
      </FlexBox>
      <FlexBox style={{ width: "33%" }}>
        <StringBox 
          name={`Override Max ${ char.hp.called }`}
          value={ char.body.hp.override_max === null ? "" : `${char.body.hp.override_max}`}
          type="number"
          onBlur={(changed: string) => {
            if (changed === "") {
              char.body.hp.override_max = null;
              if (char.body.hp.current > char.body.hp.true_max) {
                char.hp.current = char.body.hp.true_max;
              }
            } else {
              const new_hp = +changed;
              if (char.body.hp.current > new_hp) {
                char.hp.current = new_hp;
              }
              char.hp.override_max = new_hp;
            }
            char.changed();
            char.subscription_holder.resourcesChanged();
            setReloading(true);
          }}
        />
      </FlexBox>
    </FlexBox>
  );
}
